import { memo } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import CarTypeFilter from './CarTypeFilter';
import BudgetFilter from './BudgetFilter';
import RentalAgencyFilter from './RentalAgencyFilter';
import CarFlightOrigin from './CarFlightOrigin';
import PassengersFilter from '../../../Header/FilterBar/PassengersFilter';
import RateCodePreferencesFilter from './RateCodePreferencesFilter';
import TransmissionTypesFilter from './TransmissionTypesFilter';

const CarsFilterBar = ({
  tripId, selectedTab, alignFiltersCentered, filterBgColor, doHideGuestsFilterForCarRental,
}) => (
  <div className={clsx('flex flex-wrap gap-2', { 'border-b-2 pb-2': tripId, 'mt-4': !tripId, 'justify-center': alignFiltersCentered })}>
    {!tripId && !doHideGuestsFilterForCarRental && <PassengersFilter bgClassName={filterBgColor} />}
    {!tripId && <CarFlightOrigin tripId={tripId} bgClassName={filterBgColor} />}
    <CarTypeFilter tripId={tripId} selectedTab={selectedTab} bgClassName={filterBgColor} />
    <RentalAgencyFilter tripId={tripId} selectedTab={selectedTab} bgClassName={filterBgColor} />
    <BudgetFilter tripId={tripId} selectedTab={selectedTab} bgClassName={filterBgColor} />
    {!tripId && (
      <RateCodePreferencesFilter
        tripId={tripId}
        selectedTab={selectedTab}
        variant={null}
        bgClassName={filterBgColor}
      />
    )}
    {!tripId
    && (
    <TransmissionTypesFilter
      tripId={tripId}
      selectedTab={selectedTab}
      bgClassName={filterBgColor}
    />
    )}
  </div>
);

CarsFilterBar.propTypes = {
  tripId: PropTypes.string,
  selectedTab: PropTypes.number,
  alignFiltersCentered: PropTypes.bool,
  filterBgColor: PropTypes.string,
  doHideGuestsFilterForCarRental: PropTypes.bool.isRequired,
};

CarsFilterBar.defaultProps = {
  tripId: undefined,
  selectedTab: 0,
  alignFiltersCentered: false,
  filterBgColor: undefined,
};

export default memo(CarsFilterBar);
